import { render } from "./LinkPreview.vue?vue&type=template&id=4396fb9c&scoped=true&ts=true"
import script from "./LinkPreview.vue?vue&type=script&lang=ts"
export * from "./LinkPreview.vue?vue&type=script&lang=ts"

import "./LinkPreview.vue?vue&type=style&index=0&id=4396fb9c&scoped=true&lang=css"

import exportComponent from "/Users/georgemayer/Sites/apps/lognote/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4396fb9c"]])

export default __exports__